/** Compteur quotidien de courriels Resend (quota gratuit 100/jour) — visible partout dans /app. */
import { useEffect, useState } from "react";
import { EnvelopeSimple, X } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api } from "../lib/api";

const COLORS = {
  ok: "border-zinc-700 text-zinc-300",
  warn: "border-amber-500 text-amber-400",
  critical: "border-orange-500 text-orange-400",
  exceeded: "border-[#D90429] text-[#ff5c6c]",
};

export default function EmailQuotaBadge() {
  const [q, setQ] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const load = () => api.get("/email-quota").then(({ data }) => {
      setQ(data);
      if (data.level !== "ok" && sessionStorage.getItem("email_quota_warned") !== "1") {
        sessionStorage.setItem("email_quota_warned", "1");
        if (data.level === "exceeded") {
          toast.error(data.sent_today >= data.limit
            ? `Quota courriels atteint (${data.sent_today}/${data.limit}). Les envois échouent jusqu'à minuit UTC.`
            : "Resend refuse les envois : quota quotidien atteint. Les courriels échouent jusqu'à minuit UTC (codes 2FA → SMS).");
        } else {
          toast.warning(`Courriels : ${data.sent_today}/${data.limit} envoyés aujourd'hui (${data.pct} %).`);
        }
      }
    }).catch(() => {});
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, []);

  if (!q) return null;
  const bar = Math.min(100, q.pct);
  return (
    <div className="relative" data-testid="email-quota-wrap">
      <button onClick={() => setOpen((o) => !o)} data-testid="email-quota-badge" title="Courriels envoyés aujourd'hui (quota Resend)"
        className={`h-11 px-3 rounded-full bg-zinc-900 border flex items-center gap-2 text-xs font-semibold shadow-lg hover:border-zinc-500 transition-colors ${COLORS[q.level]}`}>
        <EnvelopeSimple size={16} weight={q.level === "ok" ? "regular" : "fill"} />
        <span data-testid="email-quota-count">{q.sent_today}/{q.limit}</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-[320px] rounded-xl bg-zinc-900 border border-zinc-700 shadow-2xl p-4 text-sm" data-testid="email-quota-panel">
          <div className="flex items-center justify-between">
            <span className="font-semibold text-zinc-100">Courriels aujourd'hui</span>
            <button onClick={() => setOpen(false)} className="text-zinc-500 hover:text-zinc-200" data-testid="email-quota-close"><X size={16} /></button>
          </div>
          <div className="mt-3 h-2 rounded-full bg-zinc-800 overflow-hidden">
            <div className={`h-full ${q.level === "ok" ? "bg-emerald-500" : q.level === "warn" ? "bg-amber-500" : "bg-[#D90429]"}`} style={{ width: `${bar}%` }} />
          </div>
          <div className="mt-2 flex justify-between text-xs text-zinc-400">
            <span>{q.sent_today} envoyés · {q.failed_today} échoués</span>
            <span>{q.remaining} restants</span>
          </div>
          <div className="mt-1 text-xs text-zinc-500">Plafond {q.limit}/jour ({q.limit > 100 ? "plan Resend Pro requis — sans limite quotidienne côté Resend" : "quota Resend gratuit"}) · remise à zéro dans {Math.floor(q.resets_in_min / 60)} h {q.resets_in_min % 60} min</div>
          {q.top_today?.length > 0 && (
            <div className="mt-3 text-xs" data-testid="email-quota-top">
              <div className="font-semibold text-zinc-300 mb-1">Qui a consommé le quota aujourd'hui</div>
              {q.top_today.map((t, i) => <div key={i} className="flex justify-between gap-2 text-zinc-400"><span className="truncate">{t.subject}</span><b className="text-zinc-200 shrink-0">{t.n}</b></div>)}
            </div>
          )}
          {q.level !== "ok" && <div className="mt-2 text-[11px] text-amber-300" data-testid="email-quota-hint">Le plan Resend gratuit bloque à 100/jour (3 000/mois). Pour {q.limit}/jour : plan Resend Pro 20 $ US/mois (50 000/mois, aucune limite quotidienne) sur resend.com › Settings › Billing.</div>}
          {q.last_failure && (
            <div className="mt-3 p-2 rounded bg-[#D90429]/10 border border-[#D90429]/30 text-xs text-zinc-200" data-testid="email-quota-last-failure">
              <div className="font-semibold text-[#ff5c6c]">Dernier échec · {q.last_failure.at?.slice(0, 16).replace("T", " ")} UTC</div>
              <div className="mt-0.5 text-zinc-400 line-clamp-2">{q.last_failure.error}</div>
            </div>
          )}
          <div className="mt-3 text-[11px] text-zinc-500">
            Alerte SMS auto au numéro de sécurité si un envoi échoue ou à {q.warn_pct} % du quota.
            {q.last_failure_sms && <div>Dernier SMS d'alerte : {q.last_failure_sms.slice(0, 16).replace("T", " ")} UTC</div>}
          </div>
        </div>
      )}
    </div>
  );
}
